import { InjectionToken } from '@angular/core';

export const IS_PREVIEW = new InjectionToken<string>('IS_PREVIEW');
